import { useMemo, useState } from 'react';
import { useTimeoutFn } from 'react-use';

const NODE_CONTROLS_HIDE_DELAY_MS = 150;

/**
 * Tracks whether a relationship-label node or its toolbar is hovered.
 *
 * The toolbar must receive the returned `hoverProps` too because it renders in
 * a portal below the node; its own hover keeps the state alive while the
 * pointer moves from the node to the toolbar.
 */
export function useNodeControlsHover() {
  const [isHovered, setIsHovered] = useState(false);
  // useTimeoutFn arms on mount; its initial no-op fire is harmless because the
  // hover state already starts as false.
  const [, cancelHide, scheduleHide] = useTimeoutFn(() => {
    setIsHovered(false);
  }, NODE_CONTROLS_HIDE_DELAY_MS);

  const hoverProps = useMemo(
    () => ({
      onMouseEnter: () => {
        cancelHide();
        setIsHovered(true);
      },
      onMouseLeave: () => {
        // The toolbar is rendered below the node with a gap. Delay hiding so
        // the pointer can cross that gap and reach the toolbar button.
        scheduleHide();
      },
    }),
    [cancelHide, scheduleHide]
  );

  return { isHovered, hoverProps };
}
